import React from "react";
import { Box } from "@mui/material";
import { PlusIcon } from "@heroicons/react/24/outline";
import ButtonComponent from "../customButton";
import styles from "../../styles/testCase/moduleEmptyScreen.module.scss";

const EMPTY_SCREEN_CONTENT = {
  description: "Create a module to start organizing test cases.",
  buttonLabel: "Add Module",
};

const ModuleEmptyScreen = ({
  onAddModule,
  description = EMPTY_SCREEN_CONTENT.description,
}) => {
  const handleAddModuleClick = () => {
    if (typeof onAddModule === "function") {
      onAddModule();
    }
  };

  const isAddDisabled = typeof onAddModule !== "function";

  return (
    <Box className={styles.container}>
      <p className={styles.description}>{description}</p>

      <ButtonComponent
        ctaText={EMPTY_SCREEN_CONTENT.buttonLabel}
        variant="primary"
        size='small'
        className="white bg-blue600"
        startIcon={<PlusIcon className="icon" />}
        onClick={handleAddModuleClick}
        disabled={isAddDisabled}
      />
    </Box>
  );
};

export default ModuleEmptyScreen;
